export interface IMetadataLike {
    name: string
    value: string
}

export function transformMetadata<T = Record<string, string>>(metadata: IMetadataLike[]): T {
    return metadata.reduce<Record<string, string>>((acc, data) => {
        acc[data.name] = data.value
        return acc
    }, {}) as unknown as T
}
